import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

import { Button, Dropdown, Icon } from "semantic-ui-react";
import swal from "sweetalert";

import { producaov2 as api } from "../../../../services/apis";
import { systemLogs } from "../../../../services/system_logs";
import { useRouter } from "../../../../hooks/router";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loading from "../../../../components/Loading";

import {
  Container,
  Title,
  Content,
  ContainerInputSearch,
  Input,
  SemanticTable,
  CellButtonsContainer,
  DropdownContainer,
} from "./styles";

const ListarAcademyHistories = () => {
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [histories, setHistories] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(false);
  // const [isAtivos, setIsAtivos] = useState(true);
  const [loading, setLoading] = useState(false);

  const [idLicao, setIdLicao] = useState(null);

  const router = useRouter();

  const historyStatusOptions = {
    0: "Pendente",
    1: "Publicado",
  };

  const loadHistories = useCallback(
    async (page, status = null) => {
      setLoading(true);

      const params = {
        search,
        page,
      };

      if (status !== null) {
        params.status = status;
      }

      try {
        const response = await api.get("academy/histories", {
          params,
        });

        const { histories, pages } = response.data;

        setHistories(histories);
        setPage(page);
        setPages(pages);
        setLoading(false);

        await systemLogs(
          "academy/histories/",
          "listou as mudanças pendentes no voitto academy"
        );
      } catch (err) {
        swal("Não foi possível carregar as mudanças pendentes", err, "error");
        setLoading(false);
      }
    },
    [search]
  );

  const addPage = useCallback(async () => {
    const newPage = page + 1;

    setPage(newPage);
    await loadHistories(newPage);
  }, [page]);

  const removePage = useCallback(async () => {
    if (page <= 1) {
      return;
    }

    const newPage = page - 1;

    setPage(newPage);
    await loadHistories(newPage);
  }, [page]);

  const doSearch = useCallback(
    (status = null) => {
      loadHistories(1, status);
    },
    [page, loadHistories]
  );

  const handleStatus = useCallback(
    async (index, status) => {
      try {
        const history = histories[index];
        const newHistories = [...histories];

        await api.put(`academy/histories/${history.id}`, {
          status,
        });

        newHistories[index].status = status;

        setHistories(newHistories);

        swal(
          `Curso ${history.curso.curso} !`,
          `Foi atualizado com sucesso.`,
          "success"
        );
      } catch (err) {
        console.error(err);
        swal(
          "Erro !",
          "Houve um problema ao alterar status deste curso",
          "error"
        );
      }
    },
    [histories]
  );

  useEffect(() => {
    const { status } = router.query;

    const validStatus = [0, 1].includes(Number(status)) ? status : null;

    loadHistories(1, validStatus);
  }, [router]);

  const handleStatusFilter = useCallback(
    (e, { value }) => {
      setStatusFilter(value);
      doSearch(value);
    },
    [doSearch]
  );

  const handleDelete = useCallback(
    async (index) => {
      try {
        const history = histories[index];

        if (Number(history.status) === 1) {
          return;
        }

        const newHistories = [...histories];

        await api.delete(`academy/histories/${history.id}`);

        newHistories.splice(index, 1);

        setHistories(newHistories);

        swal(
          `Mudanças do curso ${history.curso.curso} !`,
          `Foram deletadas com sucesso.`,
          "success"
        );
      } catch (err) {
        console.error(err);
        swal("Erro !", "Houve ao excluir mudanças", "error");
      }
    },
    [histories]
  );

  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Mudanças Pendentes em Cursos Publicados</Title>

        <ContainerInputSearch>
          <Input
            type="text"
            placeholder="Digite nome do curso"
            onChange={(e) => setSearch(e.target.value)}
            onKeyUp={(e) => e.key === "Enter" && doSearch()}
          />
          <Link>
            <Button onClick={doSearch}>
              <Icon name="search" />
            </Button>
          </Link>

          <DropdownContainer>
            <Dropdown
              placeholder={"Status da mudança"}
              fluid
              selection
              value={statusFilter}
              options={[
                { key: 0, value: null, text: "Todos" },
                { key: 1, value: 0, text: "Pendentes" },
                { key: 2, value: 1, text: "Publicados" },
              ]}
              onChange={handleStatusFilter}
            />
          </DropdownContainer>
        </ContainerInputSearch>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Id do Curso</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Produtor</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                Data de criação
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Status</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Acessar curso</SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body className="table-body">
            {loading ? (
              <Loading
                msg={
                  !search ? "Buscando cursos..." : `Buscando por ${search}...`
                }
              />
            ) : (
              histories.map((history, index) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{history.id}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {history.id_curso || ""}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {history?.curso?.curso || ""}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {history?.curso?.producers?.pessoa?.nome || ""}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>{history.data_create}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {historyStatusOptions[history.status]}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <CellButtonsContainer>
                      <Button
                        title="Aceitar mudanças pendentes"
                        icon="edit icon"
                        size="small"
                        color={"green"}
                        onClick={() => handleStatus(index, 1)}
                      />
                      <Button
                        title={
                          Number(history.status) === 1
                            ? "Mudanças aceitas não podem ser excluídas"
                            : "Excluir mudanças pendentes"
                        }
                        icon="trash icon"
                        size="small"
                        color={Number(history.status) === 1 ? "grey" : "red"}
                        onClick={() => handleDelete(index)}
                      />
                    </CellButtonsContainer>
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <CellButtonsContainer>
                      <Button
                        title="Ver curso"
                        size="small"
                        color={"blue"}
                        onClick={() =>
                          window.open(
                            `/admin/academy/cursos/${history?.curso.id}?academy_history=${history.id}`
                          )
                        }
                      >
                        Ver Curso
                      </Button>
                    </CellButtonsContainer>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))
            )}
          </SemanticTable.Body>
        </SemanticTable>
        {page > 1 && (
          <Button floated="left" onClick={removePage}>
            Voltar
          </Button>
        )}

        {page < pages && (
          <Button floated="right" onClick={addPage}>
            Avançar
          </Button>
        )}
      </Content>
    </Container>
  );
};

export default ListarAcademyHistories;
